<template>
  <ds-data-grid
    ref="dataGrid"
    show-actions
    show-search-term-filter
    :filters="filters"
    :search-term-placeholder="placeholder"
    :columns="columns"
    :pagination="pagination"
    :fetch-action="getInterns"
    @fetch-success="setInterns">
    <interns-page-table-item
      v-for="(intern, index) in interns"
      :key="index"
      :intern="intern"
      :index="index"
      @on-update-list="updateList"></interns-page-table-item>
  </ds-data-grid>
</template>
<script>
import { getInterns } from './internService';
import {
  TABLE_COLUMNS_HEADER, DEFAULT_PAGINATION,
} from './constants';
import InternsPageTableItem from './InternsPageTableItem.vue';

export default {
  name: 'InternsPageTable',
  components: {
    InternsPageTableItem,
  },
  data() {
    return {
      columns: TABLE_COLUMNS_HEADER,
      filters: {
        searchTerm: '',
      },
      placeholder: 'Pesquisar matrícula/nome',
      pagination: {
        ...DEFAULT_PAGINATION,
      },
      interns: [],
    };
  },
  methods: {
    getInterns(filters) {
      return getInterns(filters);
    },
    setInterns({ content, totalElements }) {
      this.interns = content;
      this.setPagination({ totalItems: totalElements });
    },
    setPagination({ totalItems = 0 }) {
      this.pagination.totalItems = totalItems;
    },
    updateList() {
      this.$refs.dataGrid.refreshTable();
    },
  },
};
</script>
